// extracted by mini-css-extract-plugin
export default {"container":"MessageText_container__c7hzp","transparentText":"MessageText_transparentText__SLx8A"};